import axios from 'axios';

export function init(apiBase, apiKey) {

	if (document.querySelector('.module-eventlist')) {

		document.querySelector('.overlay').classList.add('-white');
		document.querySelector('.overlay').classList.add('-visible');

		const locationSelect = document.querySelector('select.filter-location');
		const typeSelect = document.querySelector('select.filter-type');

		const allLocations = [];
		const allTypes = [];

		const template = document.querySelector('#listing-template').content;

		axios({
			method: 'get',
			url: apiBase + 'events',
			params: {
				daterange: 'future',
				sortBy: 'datetime',
				status: 'Published',
				private: false
			}
		})
			.then(function (response) {

				response.data.items.forEach((event) => {

					// console.log(event);

					// get timezone
					let timeZone = "UTC";
					event.links.forEach((el) => {
						if (el.rel === "timezone") {
							let timeZoneArr = el.href.split('/');
							timeZone = decodeURIComponent(timeZoneArr[timeZoneArr.length - 1]);
						}
					});

					let el = template.cloneNode(true);
					el.querySelector('.name').innerText = event.name;
					el.querySelector('.event-type').innerText = event.type;
					el.querySelector('.month').innerText = new Date(event.dateTime).toLocaleString('en-GB', { month: 'long' });
					el.querySelector('.day').innerText = new Date(event.dateTime).getDate();
					el.querySelector('.btn').setAttribute('href', window.location.pathname + '/' + event.id);
					el.querySelector('.listing').setAttribute('data-type', event.type);
					el.querySelector('.listing').setAttribute('data-location', event.address.city);

					if (event.type === 'Online Event') {

						el.querySelector('.event-location').innerText = 'Online';

					} else {

						const addressArray = [];
						if (event.venueName) { addressArray.push(event.venueName) }
						if (event.address.city) { addressArray.push(event.address.city) }
						if (event.address.country) { addressArray.push(event.address.country) }

						addressArray.forEach(function (line, i) {
							let output = '';
							if (i > 0) {
								output += ', ';
							}
							output += line;
							el.querySelector('.event-location').innerText += output;
						});

					}

					let buildTimeString = '';
					event.timeslots.forEach((timeslot, i) => {
						if (i > 0) { buildTimeString += ', '; }
						buildTimeString += `${timeslot.startTime} - ${timeslot.endTime} (${timeZone})`;
					});
					if (buildTimeString === '') { // no timeslots, so use timestamp instead
						let timeString = new Date(event.dateTime).toLocaleTimeString('en-GB', { timeZone: timeZone });
						buildTimeString = timeString.substring(0, timeString.length - 3) + ` (${timeZone})`;
					}
					el.querySelector('.event-time').innerText = buildTimeString;

					if (event.address.city !== '' && !allLocations.includes(event.address.city)) {
						allLocations.push(event.address.city);
					}

					if (event.type !== '' && !allTypes.includes(event.type)) {
						allTypes.push(event.type);
					}

					document.querySelector('.module-eventlist .left').appendChild(el);

				});

				allLocations.forEach((loc) => {
					locationSelect.innerHTML += `<option value="${loc}">${loc}</option>`;
				});

				allTypes.forEach((type) => {
					typeSelect.innerHTML += `<option value="${type}">${type}</option>`;
				});

				// Check URL params and set filters accordingly
				const urlParams = new URLSearchParams(window.location.search);
				const preSearchLocation = urlParams.has('location') ? urlParams.get('location') : '';
				const preSearchType = urlParams.has('type') ? urlParams.get('type') : '';

				document.querySelector('.filter-location').value = preSearchLocation;
				document.querySelector('.filter-type').value = preSearchType;

				document.querySelector('.overlay').classList.remove('-white');
				document.querySelector('.overlay').classList.remove('-visible');

			})
			.catch(function (response) {
				console.log(response);
			});

		locationSelect.addEventListener('change', function () {
			processFilters();
		});

		typeSelect.addEventListener('change', function () {
			processFilters();
		});

		function processFilters() {
			const targetLocation = locationSelect.value;
			const targetType = typeSelect.value;

			document.querySelectorAll('.left .listing').forEach((el) => {

				let hide = true;

				if (targetLocation === '' && targetType === '') {
					hide = false;
				} else if (targetLocation === '') {
					if (targetType === el.getAttribute('data-type')) { hide = false; }
				} else if (targetType === '') {
					if (targetLocation === el.getAttribute('data-location')) { hide = false; }
				} else {
					if (targetLocation === el.getAttribute('data-location') && targetType === el.getAttribute('data-type')) {
						hide = false;
					}
				}

				if (hide) {
					el.classList.add('-hidden');
				} else {
					el.classList.remove('-hidden');
				}

			});
		}

	}

}